import Preloader from "../helper/Preloader";
import BrandSectionOne from "../components/BrandSectionOne";
import BlogDetails from "../components/BlogDetails";
const BlogDetailsPage = () => {

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* BlogDetails */}
      <BlogDetails />

      {/* BrandSectionOne */}
      <BrandSectionOne />

    </>
  );
};

export default BlogDetailsPage;
